import { css as e, styled as o } from "styled-components";
import { MediaQuery as n } from "../../../../styles/variables.js";
import { skeletonFadeAnimation as l } from "../../../../styles/animation.js";
import { TextInputSkeletonContainer as c } from "../../../../components/TextInput/style.js";
import { Icon as u } from "../../../../components/Icon/index.js";
import { Body as m } from "../../../../styles/typography/index.js";
import { TextInput as h } from "../../../../components/TextInput/index.js";
import { Theme as t } from "../../../../styles/themes/index.js";
import { Colors as r } from "../../../../styles/colors/index.js";
const i = e`
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgb(${t.colors.Juliet});
  z-index: 1;
  position: absolute;
  padding: 0 16px;
  @supports (padding-top: env(safe-area-inset-top)) {
    padding-top: env(safe-area-inset-top);
  }

  @media ${n.SCREEN_MD_UP} {
    padding: unset;
  }
`, a = e`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;

  @media ${n.SCREEN_MD_UP} {
    ${i}
    position: inherit;
    background-color: unset;
    padding: unset;
  }
`, C = o.div`
  ${a}
  &[aria-expanded='true'] {
    ${i}
  }
`;
o.div`
  ${({ animate: s }) => l({ animate: s, disableBackground: !0 })}

  ${a}
`;
const E = o(u)`
  display: none;
  color: rgb(${t.colors.Alpha});

  @media ${n.SCREEN_SM} {
    display: inline;
    margin-right: 12px;
    font-size: 24px;
  }
`, p = e`
  width: 100%;
  padding: 8px 16px 8px 24px;

  input::placeholder {
    color: rgb(${r.Gray});
  }

  i {
    margin: 0;
    position: relative;
    background-color: unset;
  }
`, d = e`
  ${m}
  border-radius: 24px;
  transition: all 0.3s;
  padding: 8px;
  width: 40px;
  color: rgb(${t.colors.Alpha});

  &:hover:not(:disabled) {
    outline: none;
  }
  &:focus-within:not(:hover) {
    outline: none;
  }

  i {
    color: ${t.colors.Alpha};
    margin: 0 0 0 -1px;
    position: absolute;
  }

  @media ${n.SCREEN_MD_UP} {
    ${p}
    input::placeholder {
      color: rgb(${r.Gray}) !important ;
    }
  }
`, g = o(h)`
  ${d}
  position: relative;
`, I = o.form`
  position: relative;
  width: 100%;

  & > div {
    display: flex;
    justify-content: flex-end;
  }

  input::placeholder {
    color: transparent;
  }

  &[aria-expanded='true'] ${g} {
    ${p}

    button {
      background: unset;
    }
  }
`;
o(c)`
  ${d}
`;
export {
  g as Input,
  E as SearchBarBackButton,
  C as SearchBarContentWrapper,
  I as SearchBarInputContainer
};
